document.addEventListener('DOMContentLoaded', function () {
  var CFG = window.HibabeWheelCartConfig;
  var banner = document.getElementById('WheelPrizeBanner');
  if (!CFG || !banner) return;

  function safeGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) {}
  }

  var prize = safeGet('hibabeWheelPrize');
  var spun = safeGet('hibabeWheelSpun');
  var claimed = safeGet('hibabeWheelClaimed');

  if (!spun || !prize || prize === 'none' || claimed) return;

  var lockedBox = document.getElementById('WheelPrizeLocked');
  var unlockedBox = document.getElementById('WheelPrizeUnlocked');
  var lockedMsg = document.getElementById('WheelPrizeLockedMsg');
  var unlockedMsg = document.getElementById('WheelPrizeUnlockedMsg');
  var fill = document.getElementById('WheelPrizeFill');
  var claimBtn = document.getElementById('WheelClaimBtn');
  var giftPicker = document.getElementById('WheelGiftPicker');
  var giftProductSel = document.getElementById('WheelGiftProduct');
  var giftVariantSel = document.getElementById('WheelGiftVariant');
  var errorMsg = document.getElementById('WheelPrizeError');

  banner.style.display = 'block';

  function prizeLabel() {
    switch (prize) {
      case 'gift': return 'una prenda gratis de nuestros básicos';
      case 'shipping': return 'envío gratis';
      case 'pct1': return CFG.pct1 + '% de descuento en toda tu compra';
      case 'pct2': return CFG.pct2 + '% de descuento en toda tu compra';
      default: return 'tu premio';
    }
  }

  function claimBtnLabel() {
    return prize === 'gift' ? 'Elegir y reclamar mi regalo' : 'Aplicar mi premio';
  }

  function populateGiftPicker() {
    var products = CFG.giftProducts || [];
    giftProductSel.innerHTML = '';
    if (!products.length) {
      giftPicker.style.display = 'none';
      return;
    }
    products.forEach(function (p, idx) {
      var opt = document.createElement('option');
      opt.value = idx;
      opt.textContent = p.title;
      giftProductSel.appendChild(opt);
    });
    function fillVariants() {
      var p = products[Number(giftProductSel.value)];
      giftVariantSel.innerHTML = '';
      (p.variants || []).forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title === 'Default Title' ? p.title : v.title;
        giftVariantSel.appendChild(opt);
      });
    }
    giftProductSel.addEventListener('change', fillVariants);
    fillVariants();
    giftPicker.style.display = 'flex';
  }

  function render(totalCents) {
    var minCents = CFG.minPurchase * 100;
    var pct = Math.max(0, Math.min(100, (totalCents / minCents) * 100));

    if (totalCents >= minCents) {
      lockedBox.style.display = 'none';
      unlockedBox.style.display = 'block';
      unlockedMsg.textContent = '¡Ganaste ' + prizeLabel() + '! Ya puedes reclamarlo.';
      claimBtn.textContent = claimBtnLabel();
      if (prize === 'gift') {
        populateGiftPicker();
      }
    } else {
      lockedBox.style.display = 'block';
      unlockedBox.style.display = 'none';
      fill.style.width = pct + '%';
      var remaining = ((minCents - totalCents) / 100).toFixed(2);
      lockedMsg.textContent = 'Te faltan S/ ' + remaining + ' para reclamar ' + prizeLabel() + '.';
    }
  }

  function refreshFromCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  refreshFromCart();
  var poll = setInterval(refreshFromCart, 2500);

  claimBtn.addEventListener('click', function () {
    errorMsg.style.display = 'none';
    claimBtn.disabled = true;
    var originalLabel = claimBtn.textContent;
    claimBtn.textContent = 'Procesando...';

    function goToDiscount(code) {
      safeSet('hibabeWheelClaimed', '1');
      clearInterval(poll);
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routesCartUrl());
    }

    function routesCartUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
    }

    if (prize === 'gift') {
      var variantId = giftVariantSel.value;
      if (!variantId) {
        errorMsg.textContent = 'Elige una prenda para continuar.';
        errorMsg.style.display = 'block';
        claimBtn.disabled = false;
        claimBtn.textContent = originalLabel;
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: { '_wheel_gift': '1', 'Premio': 'Ruleta hibabe' }
          }]
        })
      })
        .then(function (r) {
          if (!r.ok) { throw new Error('add failed'); }
          return r.json();
        })
        .then(function () { goToDiscount(CFG.codes.gift); })
        .catch(function () {
          errorMsg.textContent = 'No pudimos agregar tu regalo. Intenta de nuevo.';
          errorMsg.style.display = 'block';
          claimBtn.disabled = false;
          claimBtn.textContent = originalLabel;
        });
    } else if (prize === 'shipping') {
      goToDiscount(CFG.codes.shipping);
    } else if (prize === 'pct1') {
      goToDiscount(CFG.codes.pct1);
    } else if (prize === 'pct2') {
      goToDiscount(CFG.codes.pct2);
    }
  });
});
